import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <main
      style={{
        minHeight: "85vh",
        display: "grid",
        placeItems: "center",
        background: "#f8fafc",
        padding: "40px",
      }}
    >
      <div
        style={{
          background: "#fff",
          maxWidth: "700px",
          padding: "60px",
          borderRadius: "20px",
          boxShadow: "0 25px 60px rgba(0,0,0,.08)",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            color: "#2563eb",
            marginBottom: "20px",
          }}
        >
          🎉 Thank You!
        </h1>

        <p
          style={{
            fontSize: "1.15rem",
            color: "#475569",
            lineHeight: 1.7,
          }}
        >
          Your strategy request has been received.
          <br />
          We'll contact you within one business day.
        </p>

        <Link
          to="/"
          style={{
            marginTop: "35px",
            display: "inline-block",
            background: "#2563eb",
            color: "#fff",
            textDecoration: "none",
            padding: "14px 32px",
            borderRadius: "10px",
            fontWeight: 700,
          }}
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
}
